var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card_bar_content_new topView"},[_vm._v(" "+_vm._s(_vm.cardContent)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }